import { render, staticRenderFns } from "./TableRecall.vue?vue&type=template&id=db8410c8&scoped=true"
import script from "./TableRecall.vue?vue&type=script&lang=js"
export * from "./TableRecall.vue?vue&type=script&lang=js"
import style0 from "./TableRecall.vue?vue&type=style&index=0&id=db8410c8&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8410c8",
  null
  
)

export default component.exports